export default __webpack_public_path__ + "assets/icons/ppt.da7d2397.svg";